import React from "react";
import i18next from "i18next";

// REISOR_STAGE22P1E_FINAL_RUNTIME_I18N_TAIL_CLEANUP_V1

const tr = (key, fallback) => {
  try {
    return i18next.t(key, { defaultValue: fallback });
  } catch {
    return fallback;
  }
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });

    const payload = {
      message: String(error?.message || error || "Unknown error"),
      stack: String(error?.stack || ""),
      componentStack: String(info?.componentStack || ""),
      href: typeof location !== "undefined" ? String(location.href || "") : "",
      ua: typeof navigator !== "undefined" ? String(navigator.userAgent || "") : "",
      at: new Date().toISOString(),
    };

    try {
      console.error("[UI_ERROR]", payload);
    } catch {}

    try {
      localStorage.setItem("ui_last_error_json", JSON.stringify(payload, null, 2));
    } catch {}
  }

  render() {
    if (this.state.error) {
      const msg = String(this.state.error?.message || this.state.error || "Unknown error");
      const stack = String(this.state.error?.stack || "");
      const componentStack = String(this.state.info?.componentStack || "");

      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#020617",
            color: "#f8fafc",
            padding: 16,
            boxSizing: "border-box",
          }}
        >
          <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12 }}>
            {tr("errors.interface_title", "Interface error")}
          </h1>

          <div style={{ opacity: 0.92, marginBottom: 12 }}>
            {tr("errors.refresh_page_hint", "Refresh the page and try again.")}
          </div>

          <div
            style={{
              background: "rgba(148,163,184,0.12)",
              borderRadius: 14,
              padding: 12,
              marginBottom: 12,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              fontFamily: "monospace",
              fontSize: 16,
              lineHeight: 1.4,
            }}
          >
            {msg}
          </div>

          {stack ? (
            <details open style={{ marginBottom: 12 }}>
              <summary style={{ cursor: "pointer", fontWeight: 700, marginBottom: 8 }}>
                JS stack
              </summary>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  background: "rgba(148,163,184,0.10)",
                  borderRadius: 12,
                  padding: 12,
                  overflowX: "auto",
                  fontSize: 12,
                  lineHeight: 1.35,
                }}
              >
                {stack}
              </pre>
            </details>
          ) : null}

          {componentStack ? (
            <details style={{ marginBottom: 12 }}>
              <summary style={{ cursor: "pointer", fontWeight: 700, marginBottom: 8 }}>
                React component stack
              </summary>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  background: "rgba(148,163,184,0.10)",
                  borderRadius: 12,
                  padding: 12,
                  overflowX: "auto",
                  fontSize: 12,
                  lineHeight: 1.35,
                }}
              >
                {componentStack}
              </pre>
            </details>
          ) : null}

          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: "12px 16px",
              borderRadius: 14,
              background: "#2563eb",
              color: "#fff",
              fontWeight: 800,
              border: "none",
            }}
          >
            {tr("common.refresh", "Refresh")}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
